import React, { useState } from 'react';
import { firestore, firebase } from '../firebaseConfig';
import { SURVEY_STYLES, SURVEY_ROOM_TYPES } from '../config/siteConfig';

const Survey = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    style: SURVEY_STYLES[0],
    roomType: SURVEY_ROOM_TYPES[0],
    challenges: '',
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await firestore.collection('surveys').add({
        ...form,
        email: form.email.toLowerCase().trim(),
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });

      const existing = await firestore.collection('subscribers')
        .where('email', '==', form.email.toLowerCase().trim()).get();
      if (existing.empty) {
        await firestore.collection('subscribers').add({
          name: form.name.trim(),
          email: form.email.toLowerCase().trim(),
          source: 'survey',
          subscribedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      setDone(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark:bg-gradient-to-r from-black to-amber-900 bg-white min-h-screen pt-28 pb-20 px-4">
      <div className="max-w-xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Style Survey</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-8">
          Tell us about your space and décor goals so we can serve you better.
        </p>

        {done ? (
          <div className="bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-700 rounded-2xl p-8 text-center">
            <p className="text-green-700 dark:text-green-400 font-semibold text-lg">
              Thank you! Your survey has been submitted.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5 bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-700 text-left">
            {error && (
              <p className="text-red-600 text-sm">{error}</p>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Name</label>
              <input
                name="name"
                required
                value={form.name}
                onChange={handleChange}
                className="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 text-sm outline-none focus:border-amber-500 dark:bg-gray-800 dark:text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
              <input
                name="email"
                type="email"
                required
                value={form.email}
                onChange={handleChange}
                className="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 text-sm outline-none focus:border-amber-500 dark:bg-gray-800 dark:text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Style preference</label>
              <select
                name="style"
                value={form.style}
                onChange={handleChange}
                className="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 text-sm outline-none focus:border-amber-500 dark:bg-gray-800 dark:text-white"
              >
                {SURVEY_STYLES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Room type</label>
              <select
                name="roomType"
                value={form.roomType}
                onChange={handleChange}
                className="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 text-sm outline-none focus:border-amber-500 dark:bg-gray-800 dark:text-white"
              >
                {SURVEY_ROOM_TYPES.map((r) => (
                  <option key={r} value={r}>{r}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Décor challenges</label>
              <textarea
                name="challenges"
                rows={4}
                value={form.challenges}
                onChange={handleChange}
                placeholder="What challenges are you facing with your space?"
                className="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 text-sm outline-none focus:border-amber-500 dark:bg-gray-800 dark:text-white"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold rounded-full disabled:opacity-60"
            >
              {loading ? 'Submitting…' : 'Submit Survey'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Survey;
